import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class ToggleStateService {
  private readonly STORAGE_KEY = 'table-toggle-states'

  getToggleState(key: string, defaultValue: boolean = true): boolean {
    const states = this.load()
    if (key in states) {
      return states[key]
    }
    states[key] = defaultValue
    this.save(states)
    return defaultValue
  }

  setToggleState(key: string, isOpen: boolean): void {
    const states = this.load()
    states[key] = isOpen
    this.save(states)
  }

  private load(): Record<string, boolean> {
    try {
      const raw = localStorage.getItem(this.STORAGE_KEY)
      return raw ? JSON.parse(raw) : {}
    } catch {
      return {}
    }
  }

  private save(states: Record<string, boolean>): void {
    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(states))
    } catch {
      // localStorage may be full or disabled
    }
  }
}
